// Componente helper para selector de horas - formato 24 horas con reloj
import React from 'react';

export const TimeSelector = ({ name, value, onChange, required = false, className = '' }) => {
    return (
        <input
            type="time"
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            step="1800"
            className={className || "w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"}
        />
    );
};

export default TimeSelector;
